import { RuntimeConfig } from "nuxt/schema";
import { ProductDetailForReviewEntity } from "~/entities/shop/ProductDetailForReviewEntity";
import { ProductReviewDetailType } from "~/types/shop/review/ProductReviewDetailType";
import { ProductReviewCategoryEntity } from "~/entities/shop/review/ProductReviewCategoryEntity";
import { contentAutoMapper } from "~/utils/mappers/content.mapper";

export const ProductReviewDetailEntity = function (data: any, config: RuntimeConfig): ProductReviewDetailType {
    return {
        title: data?.attributes?.title,
        date: data.attributes?.publishedAt,
        category: ProductReviewCategoryEntity(data?.attributes?.product_review_category?.data),
        slug: data?.attributes?.slug,
        content: data.attributes?.content?.map(content => contentAutoMapper(content, config)),
        products: data?.attributes?.products?.map(item => ProductDetailForReviewEntity(item, config)),
    };
};